import React, { useContext, useState } from "react";
import { Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";
import { ThemeContext } from "../App";

const SongList = ({ songList, setSelectedSong, back }: { songList: Track[], setSelectedSong: (song: Track) => void, back: () => void; }) => (
    <div className="column-centered">
        <p className="mt-3 mb-6">Select a song to be the start of a group:</p>
        <div className='absolute top-3 left-3 cursor-pointer row align-center mx-bw-5' onClick={back}><BackArrowIcon /> <p>Collect Different Songs</p></div>
        <div className="column track-list">
            { 
                songList.map(song => (
                    <div key={song.id} className="row align-center mx-bw-5">
                        { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                        <div className="flex-grow self-stretch row align-center cursor-pointer mx-bw-5 ml-1 md:ml-3" onClick={() => setSelectedSong(song)}>
                            <p className="">{song.name} by <i>{song.artists.map(a => a.name).join(', ')}</i></p>
                        </div>
                        { 
                            song.preview_url ?
                            <audio controls className="ml-auto">
                                <source src={song.preview_url} type="audio/mp3" />
                            </audio> : 
                            <p className="opacity-50 ml-auto">(no preview available)</p>
                        }
                    </div>
                ))
            }
        </div>
    </div>
);

const SongConfirmer = ({ selectedSong, setSelectedSong, findSongs }: { selectedSong: Track; setSelectedSong: (song: Track | null) => void, findSongs: (targetSong: Track, minSimilarity: number) => void; }) => {
    const { theme, setTheme } = useContext(ThemeContext);
    const [ minSimilarity, setMinSimilarity ] = useState(95);

    return (
        <div className="column-centered mt-5">
            <div className='absolute top-3 left-3 cursor-pointer row align-center mx-bw-5' onClick={() => setSelectedSong(null)}><BackArrowIcon /> <p>Choose Different Start Song</p></div>
            <div className="column-centered">
                { selectedSong.album.images.length > 0 && <img src={selectedSong.album.images[0].url} alt="img" className="album-art-cover-img" /> }
                <p className="text-xl font-bold mt-5">{selectedSong.name}</p>
                <p className="mb-3">by <i>{selectedSong.artists.map(a => a.name).join(', ')}</i></p>
                { 
                    selectedSong.preview_url &&
                    <audio controls>
                        <source src={selectedSong.preview_url} type="audio/mp3" />
                    </audio>
                }
            </div>
            <p className="my-2">Minimum similarity to collect: </p>
            <div className="row align-center mx-5 mx-bw-5 my-2">
                <input type="range" value={minSimilarity} min={50} max={100} step={0.1} onChange={(e) => setMinSimilarity(parseFloat(e.target.value))} className={`border border-${theme === "dark" ? 'white' : 'gray-700'} rounded-lg bg-transparent`} />
                {/*<p className="min-w-[30px]">{minSimilarity}</p>*/}
                <input type="number" value={minSimilarity} min={50} max={100} step={0.1} onChange={(e) => setMinSimilarity(parseFloat(e.target.value))} className={`border border-${theme === "dark" ? 'white' : 'gray-700'} rounded-lg bg-transparent px-2`} />
                <p className="font-bold">%</p>
            </div>
            <button className={`border border-${theme === "dark" ? 'white' : 'gray-700'} rounded-lg px-3 py-1 my-4`} onClick={() => findSongs(selectedSong, minSimilarity / 100)}>Find Similar Songs</button>
        </div>
    )   
}

interface SongSelectorProps {
    songList: Track[];
    back: () => void;
    findSongs: (targetSong: Track, minSimilarity: number) => void;
}

const SongSelector: React.FC<SongSelectorProps> = ({ songList, back, findSongs }) => {
    const [ selectedSong, setSelectedSong ] = useState<Track | null>(null);

    return (
        <div className="column-centered ">
            {
                selectedSong === null ?
                <SongList songList={songList} setSelectedSong={setSelectedSong} back={back} /> :
                <SongConfirmer selectedSong={selectedSong} setSelectedSong={setSelectedSong} findSongs={findSongs} />
            }
        </div>
    );
}

export default SongSelector;
